module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAb0lEQVQ4y2NgGBTgP5mANgacOXjhv1Lp0v+KxYv/H9l3nnQDDsxZ/9+yY/9/+54D/3fOWEucAQyxS/7DsHLktP933n3/f//jz//qQDayHAbGZgAIJ9ev/p/Xsga/ZnwGEI1h4K2Myn9y8HAyYGgDAJ3zp/T7rN2nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SI.png
// module id = 1262
// module chunks = 0